import { PcApiResponse } from '@/api/pc-api/types';
import { SettleInvoiceStatusType } from '@/constants/settle';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type SettleInvoice = {
  id: string;
  companyName: string;
  month: string;
  startedAt: string;
  finishedAt: string;
  settleInvoiceStatus: keyof typeof SettleInvoiceStatusType;
  supplyPrice: number;
  totalPrice: number;
  vat: number;
  settleId?: string;
  settleName?: string;
  requestOrganizationName?: string;
};

type GetSettleInvoiceListParams = {
  start: string;
  end: string;
};

export const getSettleInvoiceList = ({ start, end }: GetSettleInvoiceListParams) => {
  return api<PcApiResponse<SettleInvoice[]>>('get', `/pc-api/v1/${PREFIX_PATH}/settle-invoice/list`, {
    start,
    end
  });
};
